import React from 'react';

const Badge = ({ num, className }: { num: number, className?: string; }) => (
  <span className={`py-0.5 px-1 rounded-sm bg-primary text-white text-sm ${className}`}>
    {num}
  </span>
);

export default Badge;
